<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <!-- ========================================== PC ============================================== -->
    <div v-if="this.verticalNavMenuWidth === 'default'" class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!--        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />-->

        <!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

        <!--<vs-button class="px-3 mr-3" color="primary" type="border" @click="openLink">현장 센서 모니터링</vs-button>-->

        <!--        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="UserIcon" @click.stop="handleUserIcon" />-->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />

        <div class="pl-4" style="border-left: 1px solid #dae1e7;">
          <label v-for="project in myProjectList" :key="project.id"
                 class="proj-name cursor-pointer"
                 :class="{'active' : `${projectId}` === `${project.id}`}"
                 @click="$router.push(`/project/${project.id}`)"
          >
            {{ project.field_name }}
          </label>
        </div>
        <vs-spacer />

        <!--<search-bar class="mr-4" />-->

        <notification-drop-down class="mr-2"/>
        <router-link :to="{ name: 'content-mypage-info-update' }" class="mr-4">
          <div class="flex items-center justify-center">
            <feather-icon icon="SettingsIcon" />
          </div>
        </router-link>
        <profile-drop-down />

        <i18n-drop-down v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" />
        <label v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" class="mr-1" style="cursor: pointer" @click="onChangeWorkType">
          <feather-icon :icon="`${selectWorkType}Icon`" />
        </label>
      </vs-navbar>

      <div class="flex justify-end cursor-pointer ">
        <div
          class="rounded-lg bg-white p-2"
          :class="tokenRemaining < 60 * 5 ? 'swing-alert' : ''"
          style="font-size: 13px;"
        >
          남은시간: <span class="font-bold" style="color:red">{{tokenRemainingToTime}}</span>
          <span class="inline-block ml-2 px-2 py-1 rounded-lg bg-black text-white transition-transform duration-100" @click="onClickTokenRefresh">로그인 연장하기</span>
        </div>
      </div>
    </div>
    <!-- ========================================== MOBILE ============================================== -->
    <div v-else class="" :class="classObj">
      <div v-if="$route.meta.topBanner" class="m-top-banner">
        <!-- Header -->
        <div class="flex items-end justify-between" slot="header">
          <!-- 사이드메뉴 상단 로고 이미지 -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/home">
            <img class="m-0 fill-current" :src="sideTopImage" :style="sideTopImageStyle" alt="Digital SHM System"/>
          </router-link>
          <!-- /Logo -->
          <profile-drop-down />
        </div>
        <!-- /Header -->
      </div>
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <div class="mr-auto">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <label class="proj-name" >{{ projectName }}</label>
            <vs-dropdown-menu class="project-dropdown vx-navbar-dropdown" style="z-index: 530001;">
              <vs-dropdown-item
                v-for="project in myProjectList"
                @click="$router.push(`/project/${project.id}`)"
                class="px-0 py-1 text-lg "
                style="color:#1D1D1D; font-weight: 700;"
              >{{ project.field_name }}</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- <vs-spacer /> -->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />
        <notification-drop-down class="mr-2"/>
        <router-link :to="{ name: 'content-mypage-info-update' }" class="mr-4" >
          <div class="flex items-center justify-center">
            <feather-icon icon="SettingsIcon" />
          </div>
        </router-link>

        <i18n-drop-down v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" />
        <label v-if="hostname == 'miras.maot.co.kr' || hostname == '3.34.172.199'" class="mr-1" style="cursor: pointer" @click="onChangeWorkType">
          <feather-icon :icon="`${selectWorkType}Icon`" />
        </label>
      </vs-navbar>

      <div class="flex justify-end cursor-pointer ">
        <div
          class="rounded-lg bg-white p-2"
          :class="tokenRemaining < 60 * 5 ? 'swing-alert' : ''"
          style="font-size: 13px;"
        >
          남은시간: <span class="font-bold" style="color:red">{{tokenRemainingToTime}}</span>
          <span class="inline-block ml-2 px-2 py-1 rounded-lg bg-black text-white transition-transform duration-100" @click="onClickTokenRefresh">로그인 연장하기</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import I18nDropDown from "./components/I18n.vue";
import config from "../../../../public/config";
import {mapState} from "vuex";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    isSideMenu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    I18nDropDown,
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },

    myProjectList() {
      try {
        const projectList = JSON.parse(JSON.stringify(this.$store.state.member.memberInfo.projects ? this.$store.state.member.memberInfo.projects : []));
        return projectList.sort((a, b) => {
          return a.id - b.id
        })
      } catch (e) {
        return [];
      }
    },
    navbarColorLocal() {

      // projectId를 가지고 있으면 프로젝트 색상으로 변경
      // if (this.projectId) {
      //   if (this.projectInfo && this.projectInfo.project_type === "내부종사자") {
      //     return "#99C2FF";
      //   }
      //
      //   if (this.projectInfo && this.projectInfo.project_type === "도급") {
      //     return "#E2A6FF";
      //   }
      //
      //   if (this.projectInfo && this.projectInfo.project_type === "발주") {
      //     return "#96E6FF";
      //   }
      //
      //   if (this.projectInfo && this.projectInfo.project_type === "중대시민재해") {
      //     return "#FFC288";
      //   }
      // }

      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { "text-white": (this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") || (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark") };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    projectName() {
      if (this.projectId) {
        return this.projectInfo.field_name;
      }
      return "";
    },
    tokenRemaining() {
      return this.$store.state.auth.tokenRemaining
    },
    tokenRemainingToTime() {
      const hh = Math.floor(this.$store.state.auth.tokenRemaining / 3600);
      const mm = Math.floor(
        (this.$store.state.auth.tokenRemaining - hh * 3600) / 60
      );
      const ss = this.$store.state.auth.tokenRemaining - hh * 3600 - mm * 60;
      return `${hh.toString().padStart(2, "0")}:${mm
        .toString()
        .padStart(2, "0")}:${ss.toString().padStart(2, "0")}`;
    },
  },
  watch: {
    projectId() {
      this.currentProjectId = this.projectId;
    }
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      selectWorkType: "Coffee",
      sideTopImage: require('@/assets/images/logo/snb_gsnd.svg'),
      sideTopImageStyle: {
        width: "100%",
        height: "40px",
        margin: "0px",
      },
      currentProjectId: ""
    };
  },
  created() {
    this.loadSideTopImage();
    this.loadSideTopImageStyle()
  },
  async mounted() {
    const _locale = await localStorage.getItem("i18n_locale");
    this.$i18n.locale = _locale;

    if (_locale) {
      const _tempList = _locale.split("_");
      if (_tempList[1] === "construct") {
        this.selectWorkType = "Tool";
      } else if (_tempList[1] === "produce") {
        this.selectWorkType = "Filter";
      } else if (_tempList[1] === "education") {
        this.selectWorkType = "Book";
      } else if (_tempList[1] === "maot") {
        this.selectWorkType = "Coffee";
      }
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },

    handleHomeIcon() {
      if (this.projectId) {
        this.$router.push(`/project/${this.projectId}`).catch(() => {});
      } else {
        this.$router.push("/").catch(() => {});
      }
    },

    handleUserIcon() {
      this.$router.push("/mypage/workstatus");
    },

    openLink() {
      const url = "https://wipco.senceive.com/Monitor/SiteMonitor.aspx";
      window.open(url, "_blank");
    },

    async onChangeWorkType() {
      if (this.selectWorkType === "Book") {
        this.selectWorkType = "Tool";
      } else if (this.selectWorkType === "Tool") {
        this.selectWorkType = "Filter";
      } else if (this.selectWorkType === "Filter") {
        this.selectWorkType = "Coffee";
      } else {
        this.selectWorkType = "Book";
      }

      const locale = this.$i18n.locale;
      if (locale) {
        const _tempList = locale.split("_");
        if (this.selectWorkType === "Tool") {
          await this.updateLocale(`${_tempList[0]}_construct`);
        } else if (this.selectWorkType === "Filter") {
          await this.updateLocale(`${_tempList[0]}_produce`);
        } else if (this.selectWorkType === "Book") {
          await this.updateLocale(`${_tempList[0]}_education`);
        } else if (this.selectWorkType === "Coffee") {
          await this.updateLocale(`${_tempList[0]}_maot`);
        }
      }
    },
    async updateLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        await localStorage.setItem("i18n_locale", locale);
      }
    },
    async loadSideTopImage() {
      // 로컬 스토리지에 `${host_name}_side_top_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_side_top_image`)) {
        this.sideTopImage = localStorage.getItem(`${this.hostname}_side_top_image`);
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image",
      });

      // 로컬 스토리지에 저장한다
      if (config && config.path) {
        localStorage.setItem(`${this.hostname}_side_top_image`, config.path);

        this.sideTopImage = config.path;
      }
    },
    async loadSideTopImageStyle() {
      // 로컬 스토리지에 `${host_name}_side_top_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_side_top_image_style`)) {
        try {
          this.sideTopImageStyle = JSON.parse(localStorage.getItem(`${this.hostname}_side_top_image_style`));
        } catch (e) {
          console.error(e);
        }
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image_style",
      });

      // 로컬 스토리지에 저장한다
      if (config && config.path) {
        localStorage.setItem(`${this.hostname}_side_top_image_style`, JSON.stringify(config));

        this.sideTopImageStyle = config;
      }
    },
    onClickTokenRefresh () {
      this.$store.dispatch("REFRESH_TOKEN");
    }
  },
};
</script>

<style lang="scss">
.project-dropdown {
  width: 80vw;
  left: 90vw !important;
}
</style>

<style lang="scss" scoped>

.proj-name {
  padding: 8px;
  font-size: 18px;
  color: #696D71;
  font-weight: 500;
  margin-right: 8px;

  &.active {
    color: #1E0D61
  }
}

.navbar-full {
  header {
    border-radius: 0px;

    label.proj-name {
      flex: 1;
      text-align: center;
      border: none;
      padding: 0;
    }
  }
}

.m-top-banner {
  padding: .8rem 1rem;
  background: #1E0D61;
  color: #fff;
}
.m-top-banner-contents {
  display: flex;
  justify-content: space-between;
}
</style>
